
import domready from '../utils/domready.js';
  var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent );
  if( ios ) {
    if ( !standalone && safari ) {
      //browser
    } else if ( standalone && !safari ) {
      //standalone
    } else if ( !standalone && !safari ) {
      // webview
      domready(function() {
        document.querySelector('.top-bar__triggers').classList.add('top-bar__triggers--in-webview');
      });
    }
  }
